export default {
  props: ["company"],
  data() {
    return {
      company_full: this.$store.state.company_full,
    };
  },
};
